import type { Price } from '../interfaces/Price';
import type { TranslationKey } from '../types/i18n';

type TierMenuT = (
  key: TranslationKey,
  options?: { minutes: number; messages: number }
) => string;

/** Bundle tier dropdown segment: translated "N min or M messages". */
export function bundleTierCapacityMenuSegment(
  t: TierMenuT,
  plan: Pick<Price, 'minutes' | 'messages'>
): string {
  return t('Bundle tier capacity label', {
    minutes: plan.minutes ?? 0,
    messages: plan.messages ?? 0,
  });
}
